import tw, { styled } from 'twin.macro';

export const StyledContainer = styled.div``;

export const StyledCalculator = styled.div`
  ${tw`lg:container`}
  ${tw`p-2 lg:pl-3 lg:pr-1 lg:pb-3`}
  ${tw`flex flex-col lg:flex-row gap-4`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`border-2 border-x-0 lg:border-x-2 border-ui-colours-ui3`}
  ${tw`lg:rounded-lg`}

  & > :first-of-type {
    ${tw`lg:flex-[0_0_25%]`}
  }

  & > :first-of-type + * {
    ${tw`lg:flex-[0_0_75%]`}
  }
`;

export const StyledChart = styled.div`
  ${tw`bg-neutrals-n1`}
  ${tw`border lg:border-2 border-ui-colours-ui3 lg:border-[#5b9ee9]`}
  ${tw`rounded-lg`}
`;

export const StyledInputSection = styled.section`
  ${tw`flex flex-col gap-1`}
`;

export const StyledLabel = styled.label`
  ${tw`flex flex-col gap-1`}
  ${tw`mb-2`}
  ${tw`text-primary-p1 text-body-xs`}
  ${tw`font-poppins font-semi-bold`}
`;

export const StyledSelect = styled.select`
  ${tw`cursor-pointer`}
  ${tw`w-full`}
  ${tw`p-2`}
  ${tw`text-[#333333] text-body-s`}
  ${tw`font-inter font-regular`}
  ${tw`rounded-lg`}
  ${tw`border border-ui-colours-ui3`}
  ${tw`appearance-none`}
  ${tw`bg-[url('/svg/arrow-down.svg')] bg-no-repeat bg-[right_1rem_center] bg-[length:1.5em_auto]`}
`;

export const StyledInput = styled.input`
  ${tw`w-full`}
  ${tw`p-2`}
  ${tw`text-[#333333] text-body-s`}
  ${tw`font-inter font-regular`}
  ${tw`rounded-lg`}
  ${tw`border border-ui-colours-ui3`}
`;

export const StyledLinkSection = styled.div`
  ${tw`hidden lg:flex lg:flex-col`}
`;

export const StyledLinkSectionMobile = styled.div`
  ${tw`flex flex-col lg:hidden`}
`;
